// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__18Dk5","content":"Consent_content__3W0ra","footer":"Consent_footer__15tLP"};